import {
  Box,
  Button,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { toast } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { ReactComponent as CalendarGreen } from "../../../assets/child-header-icons/calendar.svg";
import { ReactComponent as Calendar } from "../../../assets/icons/Calendar.svg";
import { ReactComponent as Flag } from "../../../assets/icons/client_icon/flag.svg";
import { ReactComponent as WhiteDownArrow } from "../../../assets/icons/whiteDropdown.svg";
import { useGlobalContext } from "../../../context/GlobalContext";
import { formatDate } from "../../../utils/convertDate";
import { getIcon } from "../../../utils/iconConfig";
import CustomToast from "../CustomToast";
import PdfLoader from "../PdfLoader";
import { createSelectOrder } from "./API/submitOrder";
import { updateClient } from "./API/updateClientData";
import LogoutandDeleteModal from "../modals/LogoutandDeleteModal/LogoutandDeleteModal";
import GatiErrorModal from "../modals/GatiErrorModal/GatiErrorModal";
import * as XLSX from "xlsx";
import {
  buildDesignStats,
  recordDesignStats,
} from "../../../features/cart/api/designStats";

const OrderDetails = () => {
  const [error, setError] = useState({
    BookType: "",
    DeliveryDate: "",
    Certification: "",
    Priority: "",
    PhoneNumber: [],
    Emails: [],
  });
  const clientData = JSON.parse(localStorage.getItem("ClientData") || "{}");
  const isEditable = clientData?.clientCode === "BJPL";

  const bookTypesOptions = ["B2B Quote", "B2C Quote"];
  const priorityTypesOptions = ["Standard", "Urgent"];
  const certificationTypesOptions = [
    "IGI",
    "DGLA",
    "SGL",
    "GIA",
    "GSI",
    "None",
  ];

  const [defaultDeliveryDate, setDefaultDeliveryDate] = useState("");

  useEffect(() => {
    const calculateDefaultDate = () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let deliveryDate = new Date(today);
      let daysAdded = 0;

      while (daysAdded < 10) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        if (deliveryDate.getDay() !== 0) {
          daysAdded++;
        }
      }

      const month = deliveryDate.getMonth() + 1;
      const day = deliveryDate.getDate();
      const year = deliveryDate.getFullYear();

      return `${month}/${day}/${year}`;
    };

    setDefaultDeliveryDate(calculateDefaultDate());
  }, []);

  useEffect(() => {
    if (defaultDeliveryDate) {
      setClientOrder((prev) => ({
        ...prev,
        DeliveryDate: defaultDeliveryDate,
      }));
    }
  }, [defaultDeliveryDate]);

  const priorityColors = {
    Standard: "#5078C8",
    Urgent: "#FFD700",
    "Non-Stop": "#E77B7B",
  };

  const [clientOrder, setClientOrder] = useState({
    clientName: "",
    PhoneNo: [""],
    Email: [""],
    PurchaseOrderNo: "",
    BookType: null,
    DeliveryDate: defaultDeliveryDate,
    StampInstruction: null,
    Certification: "None",
    Priority: "Standard",
    Remarks: null,

  });

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [submitModal, setSubmitModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [emptyField, setEmptyField] = useState(false);

  const {
    setOrderDetails,
    setCartScreen,
    setOrderComplete,
    setScanned,
    setClientForm,
    gatiError,
    setGatiError,
    resetCart,
    restoreCart,
  } = useGlobalContext();

  // Holds the cart while an order is in flight, so it can be put back if that
  // order comes back as a failure.
  const cartBackupRef = useRef(null);

  const handleClientNameChange = (value) => {
    setClientOrder((prev) => {
      const updated = { ...prev, clientName: value };
      const existing = JSON.parse(localStorage.getItem("ClientData")) || {};
      const merged = { ...existing, name: value };
      localStorage.setItem("ClientData", JSON.stringify(merged));
      return updated;
    });
  };

  const handlePhoneChange = (value, index) => {
    const updatedNumbers = [...clientOrder?.PhoneNo];
    // const cleanNumber = value.replace(/\D/g, "").replace(/^91/, "");

    // Update the object instead of plain value
    updatedNumbers[index] = {
      ...updatedNumbers[index],
      value: value,
    };

    setClientOrder((prev) => ({
      ...prev,
      PhoneNo: updatedNumbers,
    }));

    // Handle errors
    setError((prev) => {
      const newErrors = [...prev.PhoneNumber];

      const currentValue = updatedNumbers[index]?.value;

      if (!currentValue) {
        newErrors[index] = "Phone number is required.";
      } else if (
        // updatedNumbers.filter((num) => num.value === currentValue).length > 1
        value.trim() &&
        updatedNumbers
          .filter((num) => num?.value && num?.value !== "91")
          .filter((num) => num?.value === value.trim())?.length > 1
      ) {
        newErrors[index] = "Duplicate phone number is not allowed.";
      } else {
        newErrors[index] = "";
      }

      return { ...prev, PhoneNumber: newErrors };
    });

    const cleanedNumbers = updatedNumbers.filter(
      (num) => num.value.trim() !== "" && num.value.trim() !== "91"
    );

    const storedClientData =
      JSON.parse(localStorage.getItem("ClientData")) || {};
    const storedOrderData =
      JSON.parse(localStorage.getItem("clientOrderData")) || {};

    const updatedClientData = {
      ...storedClientData,
      phoneNumbers: cleanedNumbers,
    };

    const updatedOrderData = {
      ...storedOrderData,
      PhoneNo: cleanedNumbers,
    };

    localStorage.setItem("ClientData", JSON.stringify(updatedClientData));
    localStorage.setItem("clientOrderData", JSON.stringify(updatedOrderData));
  };

  const handleAddandDeletePhone = (type, index) => {
    const storedClientData =
      JSON.parse(localStorage.getItem("ClientData")) || {};

    const storedOrderData =
      JSON.parse(localStorage.getItem("clientOrderData")) || {};
    if (type === "ADD") {
      setClientOrder((prev) => ({
        ...prev,
        PhoneNo: [...prev.PhoneNo, { value: "", isGati: false }],
      }));
    }
    if (type === "DELETE") {
      const updatedNumbers = clientOrder?.PhoneNo?.filter(
        (_, i) => i !== index
      );

      const filteredNumbers = updatedNumbers?.filter(
        (num) => num?.value?.trim() !== ""
      );
      setClientOrder((prev) => ({
        ...prev,
        PhoneNo: filteredNumbers,
      }));

      localStorage.setItem(
        "ClientData",
        JSON.stringify({
          ...storedClientData,
          phoneNumbers: filteredNumbers?.length > 0 ? filteredNumbers : [],
        })
      );

      localStorage.setItem(
        "clientOrderData",
        JSON.stringify({
          ...storedOrderData,
          PhoneNo: filteredNumbers?.length > 0 ? filteredNumbers : [],
        })
      );
    }
  };

  const handlePhoneNumberClearAtIndex = (index) => {
    const updatedPhoneNo = [...clientOrder?.PhoneNo];
    updatedPhoneNo[index] = "91";

    setClientOrder((prev) => ({
      ...prev,
      PhoneNo: updatedPhoneNo,
    }));

    setError((prevError) => {
      const updatedErrors = [...prevError?.PhoneNumber];
      updatedErrors[index] = "";
      return {
        ...prevError,
        PhoneNumber: updatedErrors,
      };
    });

    const cleanedPhoneNumbers = updatedPhoneNo
      .map((num) => (num === "91" ? "" : num))
      .filter((num) => num.trim() !== "");

    const storedClientData =
      JSON.parse(localStorage.getItem("ClientData")) || {};
    const updatedClientData = {
      ...storedClientData,
      phoneNumbers: cleanedPhoneNumbers,
    };

    localStorage.setItem("ClientData", JSON.stringify(updatedClientData));
  };

  const handleEmailChange = (e, index) => {
    const value = e?.target?.value?.trim();
    const updatedEmails = [...(clientOrder?.Email || "")];

    if (!updatedEmails[index]?.isGati) {
      updatedEmails[index] = {
        ...updatedEmails[index],
        value,
      };
    }

    setClientOrder((prev) => ({
      ...prev,
      Email: updatedEmails,
    }));

    setError((prev) => {
      let newErrors = [...prev.Emails];

      if (value === "") {
        newErrors[index] = "";
      } else if (
        updatedEmails.filter((email, i) => i !== index && email?.value === value)
          .length > 0
      ) {
        newErrors[index] = "Duplicate email is not allowed.";
      } else {
        newErrors[index] = "";
      }

      return { ...prev, Emails: newErrors };
    });

    const cleanedEmails = updatedEmails
      .filter((email) => email?.value?.trim() !== "")
      .map((email) => ({
        value: email?.value?.trim(),
        isGati: !!email?.isGati,
      }));

    const storedClientData =
      JSON.parse(localStorage.getItem("ClientData")) || {};

    const storedOrderData =
      JSON.parse(localStorage.getItem("clientOrderData")) || {};

    const updatedClientData = {
      ...storedClientData,
      emails: cleanedEmails,
    };

    const updatedOrderData = {
      ...storedOrderData,
      Email: cleanedEmails,
    };

    localStorage.setItem("ClientData", JSON.stringify(updatedClientData));
    localStorage.setItem("clientOrderData", JSON.stringify(updatedOrderData));
  };

  const handleAddandDeleteEmail = (type, index) => {
    const storedClientData =
      JSON.parse(localStorage.getItem("ClientData")) || {};
    const storedOrderData =
      JSON.parse(localStorage.getItem("clientOrderData")) || {};
    if (type === "ADD") {
      setClientOrder((prev) => ({
        ...prev,
        Email: [...prev.Email, ""],
      }));
    }
    if (type === "DELETE") {
      const updatedEmails = clientOrder?.Email?.filter((_, i) => i !== index);

      const filteredEmails = updatedEmails?.filter(
        (email) => email?.value?.trim() !== ""
      );

      setClientOrder((prev) => ({
        ...prev,
        Email: filteredEmails,
      }));

      setError((prev) => {
        const updatedEmailErrors = Array.isArray(prev?.Emails)
          ? prev.Emails.filter((_, i) => i !== index)
          : [];

        return {
          ...prev,
          Emails: updatedEmailErrors,
        };
      });

      localStorage.setItem(
        "ClientData",
        JSON.stringify({
          ...storedClientData,
          emails: filteredEmails?.length > 0 ? filteredEmails : [],
        })
      );

      localStorage.setItem(
        "clientOrderData",
        JSON.stringify({
          ...storedOrderData,
          Email: filteredEmails?.length > 0 ? filteredEmails : [],
        })
      );
    }
  };

  const handleEmailClearAtIndex = (index) => {
    const updatedEmails = [...clientOrder.Email];
    updatedEmails[index] = "";

    setClientOrder((prev) => ({
      ...prev,
      Email: updatedEmails,
    }));

    setError?.((prevError) => {
      const updatedErrors = [...prevError.Emails];
      updatedErrors[index] = "";
      return {
        ...prevError,
        Emails: updatedErrors,
      };
    });

    const cleanedEmails = updatedEmails.filter((email) => email.trim() !== "");

    const storedClientData =
      JSON.parse(localStorage.getItem("ClientData")) || {};
    const updatedClientData = {
      ...storedClientData,
      emails: cleanedEmails,
    };

    localStorage.setItem("ClientData", JSON.stringify(updatedClientData));
  };

  const handleBack = () => {
    setCartScreen(true);
    setOrderDetails(false);
  };

  useEffect(() => {
    let clientData = JSON.parse(localStorage.getItem("ClientData"));
    if (clientData) {
      setClientOrder((prev) => ({
        ...prev,
        clientName:
          clientData?.name == "Binnys Jewellery Pvt. Ltd. (Client not Found)"
            ? clientData?.newClientName
            : clientData?.name,
        PhoneNo:
          Array.isArray(clientData.phoneNumbers) &&
            clientData?.phoneNumbers?.length === 0
            ? [""]
            : clientData?.phoneNumbers,
        Email:
          Array.isArray(clientData?.emails) && clientData?.emails?.length === 0
            ? [""]
            : clientData?.emails,
        PurchaseOrderNo: clientData?.purchaseNo,
      }));
    }
  }, []);

  // -------- UPDATE CLIENT -------------\\

  const { mutate: updateClientMutation } = useMutation({
    mutationFn: updateClient,
  });

  // Sends one row per ordered design saying which section it came from, read
  // straight off the cart the order was built from - each row already carries
  // the section it was added under. Never blocks the order: a lost count is
  // not worth a failure on the user's screen.
  const recordOrderedDesignSources = (snapshot, orderNo) => {
    const designs = buildDesignStats(snapshot?.cartData);
    if (!designs.length) return;

    const client = snapshot?.cartKey || {};

    recordDesignStats({
      orderNo: orderNo || null,
      clientCode: client?.clientCode || "",
      clientName: client?.clientName || "",
      eventTypeId: client?.eventTypeId || "",
      eventName: client?.eventName || "",
      purchaseNo: client?.purchaseNo || "",
      designs,
    }).catch((error) => {
      console.error("Error recording design sources:", error);
    });
  };

  // -------- SUBMMIT ORDER --------------\\
  const { mutate: submitOrder, isLoading } = useMutation({
    mutationFn: createSelectOrder,
    onSuccess: (res) => {
      if (res?.status === 201) {
        localStorage.setItem("response", JSON.stringify(res));
        toast.custom((t) => <CustomToast t={t} message={res.message} />);
        localStorage.removeItem("ClientData");
        localStorage.removeItem("DynamicClient")
        localStorage.removeItem("clientOrderData");
        // Where the ordered designs were picked from - search, scan, the
        // category browser, relevant sets or recommendations. Counted only for
        // orders that were actually placed, so it is written here, off the
        // cart the order was built from, before that backup is dropped.
        recordOrderedDesignSources(cartBackupRef.current, res?.orderNo);

        // The cart was already emptied before the request went out. This
        // repeats it so both copies are definitely clear, and drops the
        // backup so nothing can put the ordered designs back.
        cartBackupRef.current = null;
        resetCart();
        setClientForm(false);
        setOrderComplete(true);
        setOrderDetails(false);
        setCartScreen(false);
      } else {
        // Not confirmed as placed, so the cart goes back exactly as it was.
        restoreCart(cartBackupRef.current);
        cartBackupRef.current = null;
        alert("Something Went wrong !");
      }
    },
    onError: (error) => {
      setSubmitModal(false)
      setLoader(false);
      // The order did not go through, so give the cart back.
      restoreCart(cartBackupRef.current);
      cartBackupRef.current = null;
      const errMsg = error?.response?.data?.message || "Something went wrong";
      if (
        errMsg?.toUpperCase()?.includes("GATI") ||
        error?.response?.status === 503
      ) {
        setGatiError(true);
        sessionStorage.removeItem("cartItems");
        sessionStorage.removeItem("ClientData");
        sessionStorage.removeItem("DynamicClient")
        sessionStorage.removeItem("scanned");
        sessionStorage.removeItem("fromHomeData");
        sessionStorage.removeItem("clientOrderData");
        setClientForm(false);
        setScanned(false);
        setOrderDetails(false);
        setCartScreen(false);
      } else {
        toast.custom((t) => (
          <CustomToast t={t} isError={true} message={errMsg} />
        ));
      }
    },
  });

  const isDateSelectable = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0);

    const isSunday = inputDate.getDay() === 0;
    const isToday = inputDate.getTime() === today.getTime();
    const isTomorrow = inputDate.getTime() === tomorrow.getTime();

    return !isSunday && !isToday && !isTomorrow;
  };

  const handleSubmitOrder = () => {
    if (
      !(
        clientOrder?.BookType &&
        clientOrder?.Certification &&
        clientOrder?.Priority &&
        clientOrder?.DeliveryDate
      )
    )
      return;
    // setLoader(true);
    let clientData = JSON.parse(localStorage.getItem("ClientData"));
    const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
    const designs = cartItems.flatMap((item) => {
      return (
        item?.quantityData?.map((des) => {
          const { key, ...quantityFields } = des || {};

          const cleanedFields = Object.fromEntries(
            Object.entries(quantityFields).map(([field, value]) => [
              field,
              value === "" ? null : value,
            ])
          );

          return {
            id: item?._id,
            styleNumber: item?.styleNumber,
            diaQlty: cleanedFields?.diaQty || null,
            itemSize: cleanedFields?.itemSize || null,
            goldColor: cleanedFields?.goldColor || null,
            goldQlty: cleanedFields?.goldQty || null,
            message: cleanedFields?.message || null,
            rhodium: cleanedFields?.rhodium || "W",
            itemPoNo: cleanedFields?.itemPoNo || "",
          };
        }) || []
      );
    });

    let newUser =
      clientData?.name === "Binnys Jewellery Pvt. Ltd. (Client not Found)";

    const cleanedPhoneNumbers = clientData?.phoneNumbers
      ?.map((n) => {
        let value = n?.value?.trim();
        // if (value.length === 12 && value.startsWith("91")) {
        //   value = value.substring(2);
        // }
        return value;
      })
      .filter((val) => val && val !== "91");

    const cleanedEmails = clientData?.emails
      ?.map((e) => e?.value?.trim())
      .filter((val) => val);

    const clientPayload = {
      clientName: newUser
        ? clientData?.newClientName?.trim()
        : clientData?.name?.trim(),
      partyNo: clientData?.partyNo,
      partyCode: clientData?.clientCode,
      ...(cleanedPhoneNumbers?.length > 0 && {
        whatsAppNos: cleanedPhoneNumbers,
      }),
      ...(cleanedEmails?.length > 0 && {
        emails: cleanedEmails,
      }),
    };

    const orderpayload = {
      clientName: clientOrder?.clientName,
      designs,
      bookType: clientOrder?.BookType || "",
      stampInstruction: clientOrder?.StampInstruction || "",
      deliveryDate: formatDate(clientOrder?.DeliveryDate) || "",
      certificate: clientOrder?.Certification || "",
      remarks: clientOrder?.Remarks || "",
      priority: clientOrder?.Priority || "",
      purchausOrder: clientOrder?.PurchaseOrderNo || "",
      partyNo: clientData?.partyNo || "",
      partyCode: clientData?.clientCode || "",
      eventTypeId: clientData?.eventTypeId || "",
    };

    const newErrors = {};

    if (!clientOrder?.BookType) {
      newErrors.BookType = "Book Type is required";
    }
    if (!clientOrder?.DeliveryDate) {
      newErrors.DeliveryDate = "Delivery Date is required";
    }
    if (!clientOrder?.Certification) {
      newErrors.Certification = "Certification is required";
    }
    if (!clientOrder?.Priority) {
      newErrors.Priority = "Priority is required";
    }

    const phoneErrors = [];
    const isValidPhone = (num) => {
      const trimmed = num?.trim();
      // const without91 = trimmed?.startsWith("91") ? trimmed?.slice(2) : trimmed;
      const without91 = trimmed;

      // return /^\d{10}$/.test(without91);
      return /^\d{12}$/.test(without91);
    };

    // clientData?.phoneNumbers?.forEach((phone, index) => {
    //   if (phone?.isGati) {
    //     phoneErrors[index] = ""; // Skip validation if isGati is true
    //     return;
    //   }

    //   const trimmed = phone?.value?.trim();
    //   // const without91 = trimmed?.startsWith("91") ? trimmed?.slice(2) : trimmed;
    //   const without91 = trimmed;

    //   if (trimmed?.length > 1 && without91 && !isValidPhone(trimmed)) {
    //     phoneErrors[index] = "Phone number must be exactly 10 digits.";
    //   } else {
    //     phoneErrors[index] = "";
    //   }
    // });

    const isValidEmail = (email) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email?.trim());

    const emailErrors = [];
    clientData?.emails?.forEach((email, index) => {
      if (email?.isGati) {
        emailErrors[index] = ""; // Skip validation if isGati is true
        return;
      }
      if (email?.value?.trim() !== "" && !isValidEmail(email?.value)) {
        emailErrors[index] = "Invalid email address.";
      } else {
        emailErrors[index] = "";
      }
    });

    const hasEmailErrors = emailErrors?.some((e) => e);

    const hasPhoneErrors = phoneErrors?.some((e) => e);
    const hasFieldErrors = Object?.keys(newErrors)?.length > 0;

    if (hasPhoneErrors || hasFieldErrors || hasEmailErrors) {
      setError((prev) => ({
        ...prev,
        ...newErrors,
        PhoneNumber: phoneErrors,
        Emails: emailErrors,
      }));
      return;
    }

    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const dateStr = `${day}-${month}-${year}`;

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const timeStr = `${hours}-${minutes}-${seconds}`;

    const worksheet = XLSX.utils.json_to_sheet(
      orderpayload?.designs.map(({ id, ...rest }) => rest)
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Designs");

    const fileName = `${orderpayload?.clientName}_${dateStr}_${timeStr}.xlsx`;

    XLSX.writeFile(workbook, fileName);

    updateClientMutation(clientPayload, {
      onSuccess: () => {
        setLoader(true);
        toast.custom((t) => (
          <CustomToast
            t={t}
            isError={false}
            message={"Please do not refresh your order is being processed."}
            color={"yellow"}
          />
        ));
        // Emptied before the order is sent, not after it replies. The server
        // creates the order the moment it receives this request, so if the tab
        // is closed while it is in flight nothing would ever run to clear the
        // cart, and the designs would come back on the next visit alongside an
        // order that was already placed. Put back below if it really fails.
        cartBackupRef.current = resetCart("ORDERED");
        submitOrder(orderpayload);
      },
      onError: (error) => {
        XLSX.writeFile(workbook, fileName);
        toast.custom((t) => (
          <CustomToast
            t={t}
            isError={true}
            message={error?.response?.data?.message || "Something went wrong"}
          />
        ));
      },
    });
  };

  const updateClientOrder = (key, value) => {
    const updated = { ...clientOrder, [key]: value };
    setClientOrder(updated);
    localStorage.setItem("clientOrderData", JSON.stringify(updated));
  };

  useEffect(() => {
    return () => {
      setCartScreen(true);
      setOrderDetails(false);
    };
  }, []);

  useEffect(() => {
    const savedOrder = localStorage.getItem("clientOrderData");
    if (savedOrder) {
      setClientOrder(JSON.parse(savedOrder));
    }
  }, []);

  const usePreventRefresh = (shouldBlock = true) => {
    useEffect(() => {
      if (!shouldBlock) return;

      const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = "";
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }, [shouldBlock]);
  };

  usePreventRefresh(loader);

  return (
    <>
      {loader && <PdfLoader open={loader} />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "95vw",
          background: "#080808",
          borderRadius: ".4vw",
          marginTop: "3vw",
          height: "80vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1vw",
            padding: "1vw",
            flexGrow: 1,
            width: "95%",
            height: "95%",
          }}
        >
          <Typography
            fontFamily={"Poppins"}
            fontSize={"1.1vw"}
            fontWeight={"300"}
          >
            <div style={{ display: "flex", gap: "1vw" }}>
              <span style={{ cursor: "pointer" }} onClick={handleBack}>
                {getIcon("ArrowCircleLeft")}
              </span>
              Order Details
            </div>
          </Typography>
          <Box sx={{ overflowY: "auto" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: ".7vw",
                }}
              >
                <div
                  style={{
                    fontSize: ".9vw",
                    fontFamily: "Poppins",
                    fontWeight: "600",
                    color: "#595959",
                  }}
                >
                  Client Name
                </div>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    placeholder="Client Name"
                    autoComplete="off"
                    value={clientOrder?.clientName}
                    disabled={!isEditable}
                    readOnly
                    // onChange={(e) => handleClientNameChange(e.target.value)}
                    style={{
                      border: ".025vw solid #595959",
                      borderRadius: ".25vw",
                      backgroundColor: "#080808",
                      height: "2.3vw",
                      width: "27vw",
                      fontSize: ".8vw",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      lineHeight: "100%",
                      color: "white",
                      paddingLeft: ".4vw",
                      outline: "none",
                    }}
                  />
                  {/* <span
                    style={{
                      position: "absolute",
                      right: ".5vw",
                      top: ".5vw",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setClientOrder((prev) => ({ ...prev, clientName: "" }))
                    }
                  >
                    {isEditable && clientOrder?.clientName && getIcon("Cross")}
                  </span> */}
                </div>
              </Box>

              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: ".7vw",
                }}
              >
                <span
                  style={{
                    fontSize: ".9vw",
                    fontFamily: "Poppins",
                    fontWeight: "600",
                    color: "#595959",
                  }}
                >
                  Mobile No.
                </span>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "1vw" }}
                >
                  {(clientOrder?.PhoneNo?.length
                    ? clientOrder.PhoneNo
                    : ["91"]
                  ).map((phone, index) => (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          gap: ".7vw",
                          alignItems: "center",
                          width: "27vw",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <Flag
                            style={{
                              position: "absolute",
                              top: ".7vw  ",
                              left: ".75vw",
                              zIndex: "2",
                            }}
                          />
                          <PhoneInput
                            country={"in"}
                            disableDropdown
                            countryCodeEditable={false}
                            value={
                              clientOrder?.PhoneNo[index]?.value
                                ? `${clientOrder?.PhoneNo[index]?.value}`
                                : `+91`
                            }
                            onChange={(value) =>
                              handlePhoneChange(value, index)
                            }
                            disabled={clientOrder?.PhoneNo[index]?.isGati}
                            inputStyle={{
                              width: "24vw",
                              backgroundColor: "#080808",
                              color: "white",
                              height: "2.3vw",
                              borderRadius: ".4vw",
                              border: error?.PhoneNumber?.[index]
                                ? "0.05vw solid #f23d3d"
                                : "0.05vw solid #595959",
                              fontSize: ".8vw",
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              lineHeight: "100%",
                            }}
                            buttonStyle={{
                              display: "none",
                            }}
                            dropdownStyle={{
                              width: "17vw",
                              borderRadius: ".6vw",
                              backgroundColor: "#333",
                              color: "white",
                              padding: ".5vw",
                            }}
                          />

                          <span
                            style={{
                              position: "absolute",
                              right: ".5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "1.3vw",
                              height: "1.3vw",
                            }}
                            onClick={() => handlePhoneNumberClearAtIndex(index)}
                          >
                            {phone.length > 2 && getIcon("Cross")}
                          </span>

                          {(!clientOrder?.PhoneNo[index].value ||
                            clientOrder?.PhoneNo[index].value?.trim() ===
                            "91") && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "4.5vw",
                                  transform: "translateY(-50%)",
                                  padding: ".25vw",
                                  background: "transparent",
                                  color: "#595959",
                                  fontSize: ".8vw",
                                  fontFamily: "Poppins",
                                  fontWeight: "500",
                                  pointerEvents: "none",
                                }}
                              >
                                Enter Mobile No.
                              </span>
                            )}
                        </div>
                        <Box
                          display={
                            index === 0 && phone.length < 10
                              ? "hidden"
                              : "block"
                          }
                        >
                          {index === 0 ? (
                            <button
                              className="add-btn"
                              style={{
                                color:
                                  clientOrder.PhoneNo.length < 2
                                    ? "#50c878"
                                    : "gray",
                                border:
                                  clientOrder.PhoneNo.length < 2
                                    ? "0.05vw solid #50c878"
                                    : "0.05vw solid gray",
                              }}
                              disabled={
                                clientOrder.PhoneNo.length < 2 ? false : true
                              }
                              onClick={() => handleAddandDeletePhone("ADD")}
                            >
                              +
                            </button>
                          ) : (
                            <button
                              className="delete-btn"
                              onClick={() =>
                                handleAddandDeletePhone("DELETE", index)
                              }
                              style={{
                                pointerEvents: clientOrder.PhoneNo?.[index]
                                  ?.isGati
                                  ? "none"
                                  : "auto",
                              }}
                            >
                              {getIcon("dustbin")}
                            </button>
                          )}
                        </Box>
                      </Box>
                      {error.PhoneNumber?.[index] && (
                        <span
                          style={{
                            color: "#f23d3d",
                            fontSize: ".7vw",
                            marginTop: "-.5vw",
                            fontFamily: "Poppins",
                          }}
                        >
                          {error.PhoneNumber[index]}
                        </span>
                      )}
                    </>
                  ))}
                </Box>
              </Box>

              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: ".7vw",
                }}
              >
                <span
                  style={{
                    fontSize: ".9vw",
                    fontFamily: "Poppins",
                    fontWeight: "600",
                    color: "#595959",
                  }}
                >
                  Email
                </span>
                {(clientOrder?.Email && clientOrder?.Email?.length > 0
                  ? clientOrder?.Email
                  : [""]
                ).map((email, index) => (
                  <Box
                    sx={{
                      display: "flex",
                      gap: ".7vw",
                      alignItems: "center",
                      width: "27vw",
                    }}
                  >
                    <Box sx={{ position: "relative", flex: 1 }}>
                      <input
                        type="email"
                        placeholder="Enter Email Address"
                        value={clientOrder?.Email?.[index]?.value}
                        onChange={(value) => handleEmailChange(value, index)}
                        disabled={clientOrder?.Email?.[index]?.isGati}
                        style={{
                          border: error?.Emails[index]
                            ? "0.05vw solid #f23d3d"
                            : "0.05vw solid #595959",
                          borderRadius: ".25vw",
                          backgroundColor: "#080808",
                          height: "2.3vw",
                          width: "24vw",
                          fontSize: ".8vw",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          lineHeight: "100%",
                          color: "white",
                          paddingLeft: ".4vw",
                          outline: "none",
                        }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: ".5vw",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "1.3vw",
                          height: "1.3vw",
                        }}
                        onClick={() => handleEmailClearAtIndex(index)}
                      >
                        {email?.length > 1 && getIcon("Cross")}
                      </span>

                      {error?.Emails[index] && (
                        <div
                          style={{
                            color: "red",
                            fontSize: ".7vw",
                            marginTop: ".3vw",
                            fontFamily: "Poppins",
                          }}
                        >
                          {error?.Emails[index]}
                        </div>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        // index === 0 && !email?.value?.includes(".com")
                        //   ? "none"
                        //   : "flex",
                        marginTop: error?.Emails[index] && "-1.3vw"
                      }}
                    >
                      {index === 0 ? (
                        <button
                          className="add-btn"
                          onClick={() => handleAddandDeleteEmail("ADD")}
                          style={{
                            color:
                              clientOrder?.Email?.length < 2
                                ? "#50c878"
                                : "gray",
                            border:
                              clientOrder?.Email?.length < 2
                                ? "0.05vw solid #50c878"
                                : "0.05vw solid gray",
                            alignSelf: "center",
                          }}
                          disabled={
                            clientOrder?.Email?.length < 2 ? false : true
                          }
                        >
                          +
                        </button>
                      ) : (
                        <button
                          className="delete-btn"
                          disabled={clientOrder?.Email[index]?.isGati}
                          onClick={() =>
                            handleAddandDeleteEmail("DELETE", index)
                          }
                          style={{
                            pointerEvents: clientOrder?.Email?.[index]?.isGati
                              ? "none"
                              : "auto",
                          }}
                        >
                          {getIcon("dustbin")}
                        </button>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
            <hr
              style={{
                width: "100%",
                backgroundColor: "#595959",
                height: ".1vw",
                border: "none",
                marginBlock: "1.4vw",
              }}
            />
            <Box>
              {/* White Box */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {/* Purchase Ord */}
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: ".7vw",
                  }}
                >
                  <div
                    style={{
                      fontSize: ".9vw",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      color: "#595959",
                    }}
                  >
                    Purchase Order Number
                  </div>
                  <Box sx={{ position: "relative" }}>
                    <input
                      type="text"
                      placeholder="Enter Order Number"
                      autoComplete="off"
                      value={clientOrder?.PurchaseOrderNo}
                      onChange={(e) => {
                        updateClientOrder("PurchaseOrderNo", e?.target?.value);
                      }}
                      style={{
                        border: ".025vw solid #595959",
                        borderRadius: ".25vw",
                        backgroundColor: "#080808",
                        height: "2.3vw",
                        width: "27vw",
                        fontSize: ".8vw",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        lineHeight: "100%",
                        color: "white",
                        paddingLeft: ".4vw",
                        outline: "none",
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: ".5vw",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "1.3vw",
                        height: "1.3vw",
                      }}
                      onClick={() => {
                        updateClientOrder("PurchaseOrderNo", "");
                      }}
                    >
                      {clientOrder?.PurchaseOrderNo && getIcon("Cross")}
                    </span>
                  </Box>
                </Box>

                {/* Book Type */}

                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: ".7vw",
                  }}
                >
                  <div
                    style={{
                      fontSize: ".9vw",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      color: "#595959",
                    }}
                  >
                    Book Type
                  </div>
                  <div>
                    <Select
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span style={{ color: "#595959" }}>
                              Select Book Type
                            </span>
                          );
                        }
                        return selected;
                      }}
                      value={clientOrder?.BookType}
                      onChange={(e) => {
                        updateClientOrder("BookType", e.target.value);
                        setEmptyField(false);
                        setError((prev) => ({ ...prev, BookType: "" }));
                      }}
                      IconComponent={WhiteDownArrow}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: ".025vw solid #595959",
                            borderRadius: ".75vw",
                            backgroundColor: "#FFFFFF",
                            height: "fit-content",
                            width: "27vw !important",
                            fontSize: ".8vw",
                            fontFamily: "Poppins",
                            lineHeight: "100%",
                            color: "white",
                            paddingLeft: ".4vw",
                            outline: "none",
                            padding: ".25vw",
                            "& .MuiList-root": {
                              paddingTop: 0,
                              paddingBottom: 0,
                            },
                            "& .MuiMenuItem-root": {
                              fontFamily: "Karla",
                              fontWeight: 500,
                              fontSize: ".9vw",
                              justifyContent: "start",
                              "&.Mui-selected": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                              "&.Mui-selected:hover": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                              "&:hover": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                            },
                          },
                        },
                      }}
                      sx={{
                        height: "2.3vw",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: ".8vw",
                        width: "27vw",
                        backgroundColor: emptyField
                          ? "#F23D3D0A"
                          : "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#ccc",
                          border: emptyField
                            ? "0.05vw solid #f23d3d"
                            : ".025vw solid #595959",
                          borderRadius: ".25vw",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: error.BookType ? "#f23d3d" : "#595959",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #595959",
                          borderColor: "#595959",
                        },
                      }}
                    >
                      {bookTypesOptions?.map((data) => (
                        <MenuItem
                          sx={{
                            backgroundColor: "#FFFFFF",
                            color: "#262626",
                          }}
                          value={data}
                        >
                          {data}
                        </MenuItem>
                      ))}
                    </Select>
                    {error?.BookType && (
                      <Typography marginY=".35vw" className="error-message">
                        {error?.BookType}
                      </Typography>
                    )}
                  </div>
                </Box>

                {/* Delivery date */}
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: ".7vw",
                  }}
                >
                  <div
                    style={{
                      fontSize: ".9vw",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      color: "#595959",
                    }}
                  >
                    Delivery Date
                  </div>

                  <div>
                    <Box
                      sx={{
                        display: "flex",
                        gap: ".7vw",
                        alignItems: "center",
                        width: "27vw",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={() => setShowDatePicker(true)}
                    >
                      <input
                        type="text"
                        placeholder="Select Date"
                        autoComplete="off"
                        readOnly
                        value={
                          clientOrder?.DeliveryDate
                            ? new Date(
                              clientOrder?.DeliveryDate
                            )?.toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            : ""
                        }
                        style={{
                          border: error?.DeliveryDate
                            ? "0.05vw solid #f23d3d"
                            : ".025vw solid #595959",
                          borderRadius: ".25vw",
                          backgroundColor: "#080808",
                          height: "2.3vw",
                          width: "24vw",
                          fontSize: ".8vw",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          lineHeight: "100%",
                          color: "white",
                          paddingLeft: ".4vw",
                          outline: "none",
                        }}
                      />
                      {clientOrder?.DeliveryDate ? (
                        <CalendarGreen />
                      ) : (
                        <Calendar />
                      )}
                    </Box>
                    {/* Material UI Modal for DatePicker */}
                    <Modal
                      open={showDatePicker}
                      onClose={() => setShowDatePicker(false)}
                      BackdropProps={{
                        style: { backgroundColor: "transparent" },
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: "70%",
                          right: "6vw",
                          transform: "translateY(-50%)",
                          bgcolor: "background.paper",
                          borderRadius: ".5vw",
                          boxShadow: 24,
                          p: 0,
                          outline: "none",
                        }}
                      >
                        <DatePicker
                          selected={
                            clientOrder?.DeliveryDate
                              ? new Date(clientOrder?.DeliveryDate)
                              : null
                          }
                          onChange={(date) => {
                            updateClientOrder("DeliveryDate", date);
                            setError((prev) => ({
                              ...prev,
                              DeliveryDate: "",
                            }));
                            setShowDatePicker(false);
                          }}
                          inline
                          filterDate={isDateSelectable}
                          minDate={(() => {
                            const minDate = new Date();
                            minDate.setHours(0, 0, 0, 0);
                            let daysAdded = 0;
                            while (daysAdded < 5) {
                              minDate.setDate(minDate.getDate() + 1);
                              if (minDate.getDay() !== 0) {
                                daysAdded++;
                              }
                            }
                            return minDate;
                          })()}
                          calendarStartDay={1}
                        />
                      </Box>
                    </Modal>
                    {error?.DeliveryDate && (
                      <Typography marginY=".35vw" className="error-message">
                        {error?.DeliveryDate}
                      </Typography>
                    )}
                  </div>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "2vw",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: ".7vw",
                  }}
                >
                  <div
                    style={{
                      fontSize: ".9vw",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      color: "#595959",
                    }}
                  >
                    Stamp Instruction
                  </div>
                  <Box sx={{ position: "relative" }}>
                    <input
                      type="text"
                      placeholder="Enter Instruction"
                      autoComplete="off"
                      value={clientOrder?.StampInstruction}
                      onChange={(e) => {
                        updateClientOrder("StampInstruction", e?.target?.value);
                      }}
                      style={{
                        border: ".025vw solid #595959",
                        borderRadius: ".25vw",
                        backgroundColor: "#080808",
                        height: "2.3vw",
                        width: "27vw",
                        fontSize: ".8vw",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        lineHeight: "100%",
                        color: "white",
                        paddingLeft: ".4vw",
                        outline: "none",
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: ".5vw",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "1.3vw",
                        height: "1.3vw",
                      }}
                      onClick={() => updateClientOrder("StampInstruction", "")}
                      StampInstruction
                    >
                      {clientOrder?.StampInstruction && getIcon("Cross")}
                    </span>
                  </Box>
                </Box>

                {/* Certification */}
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: ".7vw",
                  }}
                >
                  <div
                    style={{
                      fontSize: ".9vw",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      color: "#595959",
                    }}
                  >
                    Certification
                  </div>
                  <div>
                    <Select
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return <span style={{ color: "#595959" }}>None</span>;
                        }
                        return selected;
                      }}
                      value={clientOrder?.Certification}
                      onChange={(e) => {
                        updateClientOrder("Certification", e?.target?.value);

                        setError((prev) => ({
                          ...prev,
                          Certification: "",
                        }));
                      }}
                      IconComponent={WhiteDownArrow}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: ".025vw solid #595959",
                            borderRadius: ".75vw",
                            backgroundColor: "#FFFFFF",
                            height: "fit-content",
                            width: "27vw !important",
                            fontSize: ".8vw",
                            fontFamily: "Poppins",
                            lineHeight: "100%",
                            color: "white",
                            paddingLeft: ".4vw",
                            outline: "none",
                            padding: ".25vw",
                            "& .MuiList-root": {
                              paddingTop: 0,
                              paddingBottom: 0,
                            },
                            "& .MuiMenuItem-root": {
                              fontFamily: "Karla",
                              fontWeight: 500,
                              fontSize: ".9vw",
                              justifyContent: "start",
                              "&.Mui-selected": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                              "&.Mui-selected:hover": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                              "&:hover": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                            },
                          },
                        },
                      }}
                      sx={{
                        height: "2.3vw",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: ".8vw",
                        width: "27vw",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#ccc",
                          border: error?.Certification
                            ? "0.05vw solid #f23d3d"
                            : ".025vw solid #595959",
                          borderRadius: ".25vw",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: error?.Certification
                            ? "#f23d3d"
                            : "#595959",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #595959",
                          borderColor: "#595959",
                        },
                      }}
                    >
                      {certificationTypesOptions?.map((data) => (
                        <MenuItem
                          sx={{
                            backgroundColor: "#FFFFFF",
                            color: "#262626",
                          }}
                          value={data}
                        >
                          {data}
                        </MenuItem>
                      ))}
                    </Select>
                    {error?.Certification && (
                      <Typography marginY=".35vw" className="error-message">
                        {error?.Certification}
                      </Typography>
                    )}
                  </div>
                </Box>

                {/* Priority */}
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: ".7vw",
                  }}
                >
                  <div
                    style={{
                      fontSize: ".9vw",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      color: "#595959",
                    }}
                  >
                    Priority
                  </div>
                  <div>
                    <Select
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span style={{ color: "#595959" }}>
                              Select Priority
                            </span>
                          );
                        }
                        return (
                          <span
                            style={{
                              color: priorityColors[selected] || "#262626",
                            }}
                          >
                            {selected}
                          </span>
                        );
                      }}
                      value={clientOrder?.Priority}
                      onChange={(e) => {
                        updateClientOrder("Priority", e?.target?.value);

                        setError((prev) => ({
                          ...prev,
                          Priority: "",
                        }));
                      }}
                      IconComponent={WhiteDownArrow}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: ".025vw solid #595959",
                            borderRadius: ".75vw",
                            backgroundColor: "#FFFFFF",
                            height: "fit-content",
                            width: "27vw !important",
                            fontSize: ".8vw",
                            fontFamily: "Poppins",
                            lineHeight: "100%",
                            color: "#262626",
                            paddingLeft: ".4vw",
                            outline: "none",
                            padding: ".25vw",
                            "& .MuiList-root": {
                              paddingTop: 0,
                              paddingBottom: 0,
                            },
                            "& .MuiMenuItem-root": {
                              fontFamily: "Karla",
                              fontWeight: 500,
                              fontSize: ".9vw",
                              justifyContent: "start",
                              "&.Mui-selected": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                              "&.Mui-selected:hover": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                              "&:hover": {
                                backgroundColor: "#262626",
                                color: "white",
                                borderRadius: ".25vw",
                              },
                            },
                          },
                        },
                      }}
                      sx={{
                        height: "2.3vw",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: ".8vw",
                        width: "27vw",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#ccc",
                          border: error?.Priority
                            ? "0.05vw solid #f23d3d"
                            : ".025vw solid #595959",
                          borderRadius: ".25vw",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: error?.Priority ? "#f23d3d" : "#595959",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #595959",
                          borderColor: "#595959",
                        },
                      }}
                    >
                      {priorityTypesOptions?.map((data) => (
                        <MenuItem
                          sx={{
                            backgroundColor: "#FFFFFF",
                            color: "#262626",
                          }}
                          value={data}
                        >
                          {data}
                        </MenuItem>
                      ))}
                    </Select>
                    {error?.Priority && (
                      <Typography marginY=".35vw" className="error-message">
                        {error?.Priority}
                      </Typography>
                    )}
                  </div>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "2vw",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: ".7vw",
                  }}
                >
                  <div
                    style={{
                      fontSize: ".9vw",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      color: "#595959",
                    }}
                  >
                    Remarks
                  </div>
                  <input
                    value={clientOrder?.Remarks}
                    onChange={(e) =>
                      updateClientOrder("Remarks", e.target.value)
                    }
                    type="text"
                    placeholder="Enter your message"
                    autoComplete="off"
                    style={{
                      border: ".025vw solid #595959",
                      borderRadius: ".25vw",
                      backgroundColor: "#080808",
                      height: "2.3vw",
                      width: "88vw",
                      fontSize: ".8vw",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      lineHeight: "100%",
                      color: "white",
                      paddingLeft: ".4vw",
                      outline: "none",
                    }}
                  />
                </Box>
              </Box>
            </Box>
            {/* {emptyField && (
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  fontSize: ".8vw",
                  color: "#E77B7B",
                  marginTop: ".5vw",
                }}
              >
                Please fill this input
              </Typography>
            )} */}
          </Box>
        </Box>

        <Button
          sx={{
            width: "100%",
            height: "1.75vw",
            fontFamily: "Poppins",
            lineHeight: "1.1vw",
            background:
              clientOrder?.BookType &&
                clientOrder?.Certification &&
                clientOrder?.Priority &&
                clientOrder?.DeliveryDate
                ? "#50C878"
                : "gray",
            color: "#000000",
            fontSize: ".8vw",
            fontWeight: "600",
            borderRadius: 0,
            borderBottomLeftRadius: ".4vw",
            borderBottomRightRadius: ".4vw",
            textTransform: "none",
          }}
          onClick={() => {
            if (!clientOrder?.BookType) {
              setEmptyField(true);
              return;
            }

            setSubmitModal(true);
          }}
          disabled={isLoading}
        >
          Place Order
        </Button>
      </Box>

      <LogoutandDeleteModal
        openModal={submitModal}
        handleClose={() => setSubmitModal(false)}
        onAction={handleSubmitOrder}
        modalType={"Place Order"}
      />
      <GatiErrorModal
        openModal={gatiError}
        handleClose={() => setGatiError(false)}
      />
    </>
  );
};

export default OrderDetails;

